module.exports = __webpack_public_path__ + "img/shirt-icon.c8d45a7d.svg";